/*
 * @Author: 山白 geweijie@cai-inc.com
 * @Date: 2025-04-03 15:52:38
 * @LastEditors: 山白 geweijie@cai-inc.com
 * @LastEditTime: 2025-04-16 15:22:22
 * @FilePath: /zcy-claim-front/src/common/services/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { query, request } from '@/utils/request';
import { stringify } from 'qs';

export function fetchSpecifiedLevelTree(params) {
  return query(`/api/user/address/specifiedLevelTree?${stringify(params)}`);
}

// 获取有权限的租户列表
export function getDataRuleTenantList() {
  return query('/api/zlbuser/operator/data/permission/rule/list');
}

// 查询有权限的单位列表
export const queryDataRuleInstitution = params => {
  return query('/api/zlbuser/institution/by/dataRule', {
    params,
  });
};

// 获取企业标识
export const getEnterpriseTag = data => {
  return request('/zlb/api/expense/common/enterprise-tag', {
    method: 'POST',
    data: JSON.stringify(data.keyList),
    headers: {
      'content-type': 'application/json;charset=UTF-8',
    },
  });
};

export const getDistConfig = data => {
  return query('/zlb/api/expense/common/query/business-config', {
    method: 'post',
    data,
  });
};

// 查询机构电子档案配置

export const queryElectronicArchivesSetting = params => {
  return query('/zlb/api/archive/accounting/myself/detail', {
    params,
  });
};
